export default {
  isLoading: false,
  listaPrestacionesSel: [],
  listaPrestacionesSelFiltradas: [],
  prestacion: {},
  isNewPrestacion: false,
  isOpenModalEditarPrestacion: false,
  isOpenModalDesactivarPrestacion: false,
  isOpenModalEliminarPrestacion: false,
  filtrosPrestacionesSel: null,
  tiposPrestacion: [
    { Name: "SEP", Id: 1 },
    { Name: "CIEL", Id: 2 },
  ],
};
